export default __webpack_public_path__ + "static/media/alice-at-the-greek-1440x600.4befcd72.png";